import script from "./HeadsetIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeadsetIcon.vue?vue&type=script&lang=ts&setup=true"

import "./HeadsetIcon.vue?vue&type=style&index=0&id=54147539&lang=scss&scoped=true"

import exportComponent from "/builds/mit/fe/NEWRR/business-fe/global-os/global-retail-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54147539"]])

export default __exports__